import { SchoolOutlined } from 'components/icons';
import { Button } from 'components/ui/button';
import { t } from 'utils/getTranslations';

/** Bottom-centre pill a page shows while learning mode is on; replays the page's hints as a tour. */
export function LearningTourLauncher({ onStart }: { onStart: () => void }) {
    return (
        <Button
            variant="secondary"
            size="sm"
            onClick={onStart}
            className="shadow-dropdown fixed bottom-6 left-1/2 z-(--z-floating-ai-launcher) -translate-x-1/2 rounded-full px-4"
        >
            <SchoolOutlined className="text-base!" />
            {t('learning-mode.walk-me-through')}
        </Button>
    );
}
